import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_PHASE_RESOLVED_GRAPH_DATE } from './url-constants';

type DatetimeListDataEndpointSpecification = ApiEndpointSpecification;
export const DatetimeListDataEndpointSpecification: DatetimeListDataEndpointSpecification = {
    url: DEVICE_PHASE_RESOLVED_GRAPH_DATE,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'DatetimeListRequestParams',
    requestBodySchemaName: 'DatetimeListRequestBody',
    okResponseSchemaName: 'DatetimeListOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2
};

export const invokeDatetimeListData = Helpers.makeApiRequestFn<
    Types.DatetimeListRequestParams,
    Types.DatetimeListRequestBody,
    Types.DatetimeListOkResponse
>(DatetimeListDataEndpointSpecification);
